<template>
    <rkm-overlay>
        <rkm-layout-body title="Fila">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/regulacao/fila/List'

export default {
    components: { List },
}
</script>